import { Tooltip } from "@chakra-ui/react";
import {
  BsDatabase,
  BsDatabaseCheck,
  BsDatabaseExclamation,
  BsDatabaseFillGear,
} from "react-icons/bs";
import { TbDatabaseCog, TbWorldWww } from "react-icons/tb";
import { VscDatabase } from "react-icons/vsc";

// Ingestion runs through this state machine:
//
//   File upload / collection / text blob:
//     empty → queued → in_process → ready_for_use
//                          ↓
//                    retry_pending → in_process (on retry) → ...
//                          ↓ (max retries)
//                       failed
//
//   Web crawl (http via Apify):
//     empty → crawling → in_process → ready_for_use
//                            ↓ (max retries)
//                          failed
//
// `initialized` is kept (legacy rows) and `initilized` is an alias for
// the pre-existing typo in older code so existing data still renders.
const iconProperties = {
  empty: { label: "Empty", children: <VscDatabase /> },
  initialized: { label: "Initializing", children: <BsDatabase /> },
  initilized: { label: "Initializing", children: <BsDatabase /> }, // legacy typo
  queued: { label: "Queued", children: <BsDatabase color="#A0AEC0" /> },
  crawling: {
    label: "Crawling pages",
    children: <TbWorldWww color="#3182CE" />,
  },
  in_process: { label: "Indexing", children: <TbDatabaseCog /> },
  retry_pending: {
    label: "Retrying after a transient error",
    children: <BsDatabaseFillGear color="#D69E2E" />, // amber
  },
  ready_for_use: {
    label: "Ready to use",
    children: <BsDatabaseCheck color="green" />,
  },
  failed: {
    label: "Failed",
    children: <BsDatabaseExclamation color="red" />,
  },
};

export default function DataSourceStatusIcon({ ds_status }) {
  // Defensive fallback so any future backend-added status doesn't crash
  // the row. Renders the empty icon with the raw status string in the
  // tooltip so we can spot unknowns in support tickets.
  const entry = iconProperties[ds_status] || {
    label: `Unknown: ${ds_status ?? "—"}`,
    children: <VscDatabase color="#CBD5E0" />,
  };
  return (
    <Tooltip label={entry.label || ""}>
      <div style={{ marginLeft: "8px" }}>{entry.children}</div>
    </Tooltip>
  );
}
